import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a53d6e48"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  ref: "sceneContainer",
  style: {"width":"100%","height":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_more_info_holder = _resolveComponent("more-info-holder")!
  const _component_search_button = _resolveComponent("search-button")!
  const _component_movement_focus_button = _resolveComponent("movement-focus-button")!
  const _component_globe_foot_bar = _resolveComponent("globe-foot-bar")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, {
    class: _normalizeClass(_ctx.isMobile)
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_overlay, {
            modelValue: _ctx.overlay,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.overlay) = $event)),
            opacity: "1",
            class: "video-overlay",
            scrim: "#fff",
            style: {"background-color":"white"},
            ripple: false
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                class: "loaderGif",
                src: require('@/assets/video/loader_v5.gif'),
                alt: "loading"
              }, null, 8, _hoisted_1)
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_more_info_holder, { isOpen: _ctx.showMoreInfo }, null, 8, ["isOpen"]),
          _createElementVNode("div", _hoisted_2, null, 512),
          _createVNode(_component_search_button, { onSelectedCountry: _ctx.selectedCountry }, null, 8, ["onSelectedCountry"]),
          _createVNode(_component_movement_focus_button),
          _createVNode(_component_globe_foot_bar, {
            class: "globe-foot-bar-component",
            onZoom: _ctx.handleZoom
          }, null, 8, ["onZoom"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}